import { http, id } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    districts: []
  },

  actions: {
    async getDistricts ({ commit, state }, { firefighterId, params = {} } = {}) {
      const response = await http.get(`firefighters/${id(firefighterId)}/districts`, { params })
      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetDistricts ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.districts = items
    }
  }
}
